module.exports = __webpack_public_path__ + "img/s4.8aadd16f.svg";